import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var _this = this;

import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';

import { getDecodedId } from '../../Utils/ProductUtils';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { StyledPinkButton } from '../AccountVisualizer/AccountVisualizerStyles';
import { StyledFlexWrapper, LabelAndErrorWrapper } from '../VisualizerSaveModal/VisualizerSaveModalStyles';
import { getThumbnailUrl } from '../../Utils/VisualizerUtils';

var _ref5 = React.createElement(
  'h3',
  null,
  'Share Your Design'
);

var _ref6 = React.createElement(
  'label',
  { htmlFor: 'visualizerEmailSender' },
  'Sender Email'
);

var _ref7 = React.createElement(
  'label',
  { htmlFor: 'visualizerEmailRecipient' },
  'Recipient Email'
);

var _ref8 = React.createElement(
  'label',
  { htmlFor: 'visualizerEmailNote' },
  'Write a message!'
);

var _ref9 = React.createElement(Field, {
  component: 'textarea',
  name: 'note',
  type: 'text',
  id: 'visualizerEmailNote',
  maxLength: 1065
});

var _ref10 = React.createElement(LoadingSpinner, null);

var VisualizerEmailForm = function VisualizerEmailForm(_ref) {
  var selectedProducts = _ref.selectedProducts,
      relativeUrl = _ref.relativeUrl,
      setIsFormSuccess = _ref.setIsFormSuccess;

  var sendToZaius = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload, formActions) {
      var fetchResponse, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('https://zaius-proxy-service-33tdfxk4ua-ue.a.run.app/zaius-proxy/v3/events', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              });

            case 3:
              fetchResponse = _context.sent;
              _context.next = 6;
              return fetchResponse.json();

            case 6:
              data = _context.sent;

              // Klayvio sends a 1 (SUCCESS) or 0 (FAIL) for response
              if (data === 1) {
                formActions.setSubmitting(false);
                setIsFormSuccess(true);
              } else if (data === 0) {
                alert('Please Try submitting again. If this continues, please contact support');
              }
              return _context.abrupt('return', data);

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);
              return _context.abrupt('return', _context.t0);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 11]]);
    }));

    return function sendToZaius(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var createZaiusPayload = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formValues, formActions) {
      var zaiusPayload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // send zaius payload
              zaiusPayload = {
                token: 'SCPnak',
                event: 'Shared Visualizer',
                customer_properties: {
                  $email: formValues.recipient
                },
                properties: {
                  visualizer_items: JSON.stringify(selectedProducts.map(function (product) {
                    return {
                      name: product.parentTitle,
                      handle: product.handle,
                      price: product.price,
                      product_id: getDecodedId(product.variantId),
                      image_url: product.image.thumbnailImg
                    };
                  })),
                  visualizer_image_url: getThumbnailUrl({ relativeUrl: relativeUrl }),
                  visualizer_link: 'https://www.dormify.com' + relativeUrl,
                  visualizer_subtotal: selectedProducts.reduce(function (subtotal, product) {
                    return subtotal + parseFloat(product.price);
                  }, 0),
                  visualizer_note: formValues.note,
                  visualizer_builder_email: formValues.sender,
                  visualizer_type: relativeUrl.includes('/wall-visualizer') ? 'wall_visualizer' : 'bed_visualizer'
                }
              };
              _context2.next = 3;
              return sendToZaius(zaiusPayload, formActions);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function createZaiusPayload(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  return React.createElement(
    Formik,
    {
      initialValues: {
        recipient: '',
        note: 'Hey there! Check out my design from Dormify.',
        sender: window.Dormify.customerEmail !== '' ? window.Dormify.customerEmail : ''
      },
      validate: function validate(values) {
        var errors = {};
        if (!values.sender) {
          errors.sender = 'Required.';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.sender)) {
          errors.sender = 'Invalid Email Address.';
        }

        if (!values.recipient) {
          errors.recipient = 'Required.';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.recipient)) {
          errors.recipient = 'Invalid Email Address.';
        }
        if (!values.note) {
          errors.note = 'Required.';
        } else if (values.note.lenth > 1064) {
          errors.note = 'Sorry! That\'s too long (1064 character limit)';
        }
        return errors;
      },
      onSubmit: function onSubmit(values, actions) {
        createZaiusPayload(values, actions);
      }
    },
    function (_ref4) {
      var errors = _ref4.errors,
          touched = _ref4.touched,
          isSubmitting = _ref4.isSubmitting;

      return React.createElement(
        Form,
        null,
        React.createElement(
          StyledFlexWrapper,
          { component: 'VisualizerEmailForm' },
          _ref5,
          React.createElement(
            LabelAndErrorWrapper,
            null,
            _ref6,
            React.createElement(
              'p',
              null,
              touched.sender && errors.sender
            )
          ),
          React.createElement(Field, {
            name: 'sender',
            type: 'email',
            placeholder: 'Please enter email address',
            id: 'visualizerEmailSender',
            required: true
          }),
          React.createElement(
            LabelAndErrorWrapper,
            null,
            _ref7,
            React.createElement(
              'p',
              null,
              touched.recipient && errors.recipient
            )
          ),
          React.createElement(Field, {
            name: 'recipient',
            type: 'email',
            placeholder: 'Please enter email address',
            id: 'visualizerEmailRecipient',
            required: true
          }),
          React.createElement(
            LabelAndErrorWrapper,
            null,
            _ref8,
            React.createElement(
              'p',
              null,
              touched.note && errors.note
            )
          ),
          _ref9,
          React.createElement(
            StyledPinkButton,
            { type: 'submit', disabled: isSubmitting },
            isSubmitting ? _ref10 : 'Send Email'
          )
        )
      );
    }
  );
};

VisualizerEmailForm.propTypes = {
  selectedProducts: PropTypes.array.isRequired,
  relativeUrl: PropTypes.string.isRequired,
  setIsFormSuccess: PropTypes.func.isRequired
};

export default VisualizerEmailForm;